import { jsx as a, jsxs as b } from "react/jsx-runtime";
import y from "clsx";
import '../../theme.css';import '../../_assets/index.Ccqs4UpR.css';/* empty css                                          */
var V = "ButtonVanilla_buttonInner__1l9xofl1", f = "ButtonVanilla_buttonContent__1l9xofl2", k = { L: "ButtonVanilla_buttonSizes_L__1l9xofl3", M: "ButtonVanilla_buttonSizes_M__1l9xofl4", S: "ButtonVanilla_buttonSizes_S__1l9xofl5", XS: "ButtonVanilla_buttonSizes_XS__1l9xofl6" }, v = "ButtonVanilla_buttonIconOnly__1l9xofl7", l = "ButtonVanilla_buttonIcon__1l9xofl8", N = { primary: "ButtonVanilla_buttonVariants_primary__1l9xofl9", secondary: "ButtonVanilla_buttonVariants_secondary__1l9xofla", tertiary: "ButtonVanilla_buttonVariants_tertiary__1l9xoflb", link: "ButtonVanilla_buttonVariants_link__1l9xoflc", primaryOnDark: "ButtonVanilla_buttonVariants_primaryOnDark__1l9xofld", tertiaryOnDark: "ButtonVanilla_buttonVariants_tertiaryOnDark__1l9xofle", linkOnDark: "ButtonVanilla_buttonVariants_linkOnDark__1l9xoflf", terminal: "ButtonVanilla_buttonVariants_terminal__1l9xoflg" }, D = { square: "ButtonVanilla_buttonShape_square__1l9xoflh", round: "ButtonVanilla_buttonShape_round__1l9xofli", circle: "ButtonVanilla_buttonShape_circle__1l9xoflj" }, O = "ButtonVanilla_baseButton__1l9xofl0";
const g = ({
  type: x = "button",
  children: o,
  variant: d = "primary",
  size: m = "M",
  shape: p = "round",
  disabled: B = !1,
  icon: t,
  iconPosition: n,
  isIconOnly: r,
  onClick: _,
  className: c,
  ariaLabel: e,
  href: u,
  target: i,
  rel: h
}) => {
  const s = y(
    O,
    N[d],
    k[m],
    D[p],
    r && v,
    c
  ), S = h ?? (i === "_blank" ? "noopener noreferrer" : void 0);
  return u ? /* @__PURE__ */ a(
    "a",
    {
      href: u,
      target: i,
      rel: S,
      "aria-label": e,
      onClick: _,
      className: s,
      children: /* @__PURE__ */ b("span", { className: V, children: [
        t && n === "left" && /* @__PURE__ */ a("span", { className: l, "aria-hidden": "true", children: t }),
        !r && /* @__PURE__ */ a("span", { className: f, children: o }),
        t && n === "right" && /* @__PURE__ */ a("span", { className: l, "aria-hidden": "true", children: t })
      ] })
    }
  ) : /* @__PURE__ */ a(
    "button",
    {
      type: x ? "button" : "submit",
      onClick: _,
      disabled: B,
      "aria-label": e,
      className: s,
      children: /* @__PURE__ */ b("span", { className: V, children: [
        t && n === "left" && /* @__PURE__ */ a("span", { className: l, "aria-hidden": "true", children: t }),
        !r && /* @__PURE__ */ a("span", { className: f, children: o }),
        t && n === "right" && /* @__PURE__ */ a("span", { className: l, "aria-hidden": "true", children: t })
      ] })
    }
  );
};
export {
  g as ButtonVanilla
};
